"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// biome-ignore lint/style/useImportType: required for JSX runtime compatibility with older toolchains
const react_1 = require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const Popover_1 = tslib_1.__importStar(require("../popover/Popover"));
const DEFAULT_PLACEMENT = Popover_1.PLACEMENT_MAP.BOTTOM;
const DEFAULT_WIDTH = 250;
const ActionBarOverlay = (0, react_1.forwardRef)((props, ref) => {
    const { children, show, preRender, id, title, onClick = noop_1.default, width = DEFAULT_WIDTH, style = {}, className, placement = DEFAULT_PLACEMENT, ...remainingProps } = props;
    const adjustedStyles = { ...style, width };
    const adjustedClassName = preRender && !show ? (0, classnames_1.default)(className, 'position-offscreen') : className;
    const popoverTitleClasses = (0, classnames_1.default)('ActionBarItemPopover text-color-dark', className);
    const popoverContentClasses = (0, classnames_1.default)('ActionBarItemPopover', className);
    return ((0, jsx_runtime_1.jsxs)(Popover_1.default, { ref: ref, id: id, onClick: onClick, placement: placement, ...remainingProps, style: adjustedStyles, className: adjustedClassName, children: [title && (0, jsx_runtime_1.jsx)(Popover_1.default.Title, { className: popoverTitleClasses, children: title }), (0, jsx_runtime_1.jsx)(Popover_1.default.Content, { className: popoverContentClasses, children: children })] }));
});
exports.default = ActionBarOverlay;
